module.exports = __webpack_public_path__ + "static/media/03.e6846f81.mp3";